<form [formGroup]="form">
  <div class="gap-lg flex flex-col" formArrayName="modalites">
    @for (control of modalitesForm.controls; track $index; let idx = $index) {
      <app-expansion-panel [titre]="'Modalité ' + (idx + 1)" [item]="form" [isOpen]="true">
        <div class="px-lg pt-lg pb-xl" [formGroupName]="idx">
          <label for="nom" hlmLabel labelRequired>Nom de la modalité</label>
          <input id="nom" hlmInput formControlName="nom" />
        </div>
      </app-expansion-panel>
    }
    <app-button-add-new (click)="addModalite()" label="Ajouter une modalité" />
  </div>
</form>
